module.exports = __webpack_public_path__ + "static/media/06.646ed8c8.jpg";